import { render, staticRenderFns } from "./SourcesTableView.vue?vue&type=template&id=bc59f9b6&scoped=true&"
import script from "./SourcesTableView.vue?vue&type=script&lang=js&"
export * from "./SourcesTableView.vue?vue&type=script&lang=js&"
import style0 from "./SourcesTableView.vue?vue&type=style&index=0&id=bc59f9b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc59f9b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VDataTable,VIcon,VSimpleCheckbox})
